import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useServerInfo } from '@go-client/context/ServerInfoContext';
import { mapBy } from '@go-shared/lib/functional';
import {
  BareSailingDay,
  BareSimpleSailingDay,
  SailingDay,
  SimpleSailingDay,
} from '@go-shared/types/sailing';
import { SimpleTemplate } from '@go-shared/types/template';
import React, { useState } from 'react';
import { BubbleButton } from './BubbleUI';

interface DayMarkersButtonProps {
  sailingDay?: BareSailingDay | SailingDay | SimpleSailingDay | BareSimpleSailingDay;
  template?: SimpleTemplate;
  noDefaultText?: boolean;
}

export function DayMarkersButton(props: DayMarkersButtonProps) {
  const { brand } = useServerInfo();
  const [visible, setVisible] = useState(0);

  const dayThemesMap = mapBy(brand.dayThemes, '_id');

  const items: { icon: IconProp; text: string }[] = [];

  const dayTheme = dayThemesMap[props.sailingDay?.dayTheme || props.template?.dayTheme || ''];

  if (dayTheme) {
    items.push({
      icon: 'shirt',
      text: dayTheme.name,
    });
  }

  const [mouseOver, setMouseOver] = useState(false);

  return (
    <div
      className="relative flex flex-col"
      onMouseEnter={() => setMouseOver(true)}
      onMouseLeave={() => setMouseOver(false)}
    >
      {items.map((itm, i) => (
        <BubbleButton
          key={itm.text}
          variant="navy"
          className="bg-white-i whitespace-nowrap border border-navy text-xs text-left"
          style={{
            display: i === visible ? 'block' : 'none',
            pointerEvents: items.length > 1 ? 'inherit' : 'none',
            cursor: items.length > 1 ? 'pointer' : 'none',
          }}
          inverse
          onClick={() => setVisible((visible + 1) % items.length)}
        >
          <div className="flex items-center">
            <FontAwesomeIcon size="sm" icon={itm.icon} className="mr-2" />
            <div className="text-center">{itm.text}</div>
          </div>
        </BubbleButton>
      ))}
      <div
        className="absolute w-full flex items-center justify-center space-x-1"
        style={{
          pointerEvents: 'none',
          zIndex: 1,
          bottom: 4,
          opacity: mouseOver && items.length > 1 ? 1 : 0,
          transition: 'opacity 0.5s ease',
        }}
      >
        {items.map((itm, i) => (
          <FontAwesomeIcon
            key={itm.text}
            fontSize={5}
            icon="circle"
            className={i === visible ? 'text-navy' : 'text-smoke'}
          />
        ))}
      </div>
      {items.length === 0 && !props.noDefaultText && (
        <BubbleButton
          key="No markers"
          variant="slate"
          disabled
          className="bg-white-i whitespace-nowrap border border-eggshell-darkest text-xs"
          inverse
        >
          No markers
        </BubbleButton>
      )}
    </div>
  );
}
